



































































import { Component, Vue } from 'vue-property-decorator';
import Step from './models/Step';
import AppModal from '../../shared/components/ui/Modal.vue';
import {League, LeagueDataItem} from "@/modules/create-league/types";
import createLeagueService from './services/CreateLeagueService';

@Component({
    components: {
        AppModal
    },
})
export default class Login extends Vue {
    private leagueCreated: boolean = false;
    private steps: Step[] = [
        {
            title: 'create_league.step1_breadcumb',
            number: 1,
        }, {
            title: 'create_league.step2_breadcumb',
            number: 2,
        }, {
            title: 'create_league.step3_breadcumb',
            number: 3,
        }, {
            title: 'create_league.step4_breadcumb',
            number: 4,
        },
    ];

    private league: League = {
        title: '',
        competition: '',
        participants: 0,
        price: 5,
        public: true,
        serie_start: 0,
        serie_end: 0
    };

    private updateLeagueStatus(items: LeagueDataItem[]) {
        items.forEach((item: LeagueDataItem) => {
            //@ts-ignore
            this.league[item.key] = item.value;
        })
    }

    private async submit() {
        try {
            await createLeagueService.createLeague(this.league);
            this.leagueCreated = true
        } catch (e) {
            console.log(e)
        }
    }

    get nextStep(): string {
        const currentStep = this.$route.meta.step;
        return currentStep === 1 ? `/create-league/step${currentStep + 1}` : `step${currentStep + 1}`;
    }

    get previousStep(): string {
        const currentStep = this.$route.meta.step;
        return currentStep === 2 ? `/create-league` : `step${currentStep - 1}`;
    }

    get currentStep(): number {
        return this.$route.meta.step;
    }

}
